import styled from 'styled-components';

export const FloatingButton = styled.div`
  /* position: fixed; */
  /* bottom: 1rem;
  right: 1rem;
  z-index: 1000;
  background: var(--color-primary);
  color: var(--text-color); */
  padding: 0.5rem 1rem;
  /* border: none; */
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;

  /* &:hover {
    background: var(--highlight);
  } */
`;
